module.exports = __webpack_public_path__ + "img/drug2_tc_3.bd4b09af.png";